export function assert(whatever: any) {
  if (!whatever) {
    throw new Error('Assert failed');
  }
}
